import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-observations-table',
  templateUrl: './observations-table.component.html',
  styleUrls: ['./observations-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ObservationsTableComponent {
  @Input() observations: any;
  @Input() columnsToDisplay: any[];
  expandedElement: any;

  constructor(public translateService: TranslocoService) {}
}
